import { Card, Tag, Tooltip, Typography } from "antd";

import { Link } from "react-router-dom";
import moment from "moment";

const { Title, Text } = Typography;

const JobCardComponent = ({ job, onClick, relevant = false }) => {
  const formatFullAddress = (location = {}) => {
    if (!location) return { location: "-", requirementType: "Remote" };

    const { locality, city, state, country, displayText } = location;

    const parts = [
      locality,
      city,
      state,
      country === "IN" ? "India" : country,
    ].filter(Boolean);
    console.log(parts);
    // Fallback if everything is empty
    if ((!parts.length || parts.length == 1) && displayText) {
      return { location: displayText, requirementType: "Remote" };
    }

    return { location: parts.join(", "), requirementType: "Onsite" };
  };
  const location = formatFullAddress(job.location).location;
  const contractType = formatFullAddress(job.location).requirementType;
  const v = job.relevant || "pending";
  const icp = job.icp || "pending";
  const vBy = job.relevantBy || { name: "" };
  const icpBy = job.icpBy || { name: "" };
  const color =
    v === "relevant" ? "green" : v === "non_relevant" ? "red" : "default";
  const icpColor =
    icp === "ICP" ? "green" : icp === "Non_ICP" ? "red" : "default";

  return (
    <Card
      className="cardComponent"
      style={{
        height: "100%",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "20px",
      }}
      title={
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: `${contractType == "Remote" ? "#3699FF" : "#13487D"}  `, //
            color: "black",
            padding: "18px 12px",
            borderRadius: "20px 20px 0px 0px",
            margin: "0px , -14px",
          }}
        >
          <div style={{ maxWidth: 190 }}>
            <Tooltip title={job.title}>
              <a
                href={job?.source?.url || "#"}
                target="_blank"
                rel="noreferrer"
              >
                <Title
                  level={4}
                  style={{
                    marginBottom: 0,
                    fontSize: "16px",
                    fontWeight: "500",
                    color: "white",
                    textDecoration: "underline",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {`${job.title}`}
                </Title>
              </a>
            </Tooltip>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "2px",
              alignItems: "center",
            }}
          >
            <Tag
              color={relevant ? icpColor : color}
              style={{
                cursor: "pointer",
                userSelect: "none",
                borderRadius: "10px",
              }}
              onClick={() => onClick(job)}
            >
              {relevant ? icp : v}
            </Tag>
            <div
              style={{
                marginBottom: 0,
                fontSize: "14px",
                fontWeight: "500",
                color: "white",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >{`${job?.jobId}`}</div>
          </div>
        </div>
      }
    >
      {/* <Link
        to={{
          pathname: "/company/requirement_description",
          state: {
            data: job,
          },
        }}
      > */}
      <div style={{ marginTop: 1 }}>
        <div style={{ marginTop: 6, fontSize: "12px" }}>
          <Text>
            <strong>Company :</strong>
            <span style={{ color: "#666666" }}> {job.company?.name}</span>
          </Text>
        </div>
        <div style={{ marginTop: 12, fontSize: "12px" }}>
          <Text>
            <strong>Contract Type :</strong>
            <span style={{ color: "#666666" }}>
              {" "}
              {job.employment?.contractType}
            </span>
          </Text>
        </div>
        <div style={{ marginTop: 12, fontSize: "12px" }}>
          <Text>
            <strong>Contract Time :</strong>
            <span
              style={{ color: "#666666" }}
            >{`${job.employment?.contractTime}`}</span>
          </Text>
        </div>
        <div style={{ marginTop: 12, fontSize: "12px" }}>
          <Text>
            <strong>Salary :</strong>
            <span style={{ color: "#666666" }}>
              {" "}
              {`${job.salary?.min || "-"}/${job.salary?.max || "-"}`}
            </span>
          </Text>
        </div>

        {/* Experience */}

        {/* Location */}
        <div style={{ marginTop: 12, fontSize: "12px" }}>
          <Text>
            <strong>Location :</strong>

            <span style={{ color: "#666666" }}>
              {location} | {contractType}
            </span>
          </Text>
        </div>
        <div style={{ marginTop: 12, fontSize: "12px" }}>
          <Text>
            <strong>Posted At :</strong>
            <span style={{ color: "#666666" }}>
              {`${moment(job.postedAt).format("DD/MM/YYYY")}`}
            </span>
          </Text>
        </div>
        <div style={{ marginTop: 12, fontSize: "12px" }}>
          <Text>
            <strong>Relevant : </strong>
            <Tag
              color={color}
              style={{
                cursor: "pointer",
                userSelect: "none",
                borderRadius: "10px",
              }}
            >
              {relevant ? vBy.name : v}
            </Tag>
          </Text>
        </div>
        <div style={{ marginTop: 12, fontSize: "12px" }}>
          <Text>
            <strong>ICP : </strong>
            <Tag
              color={icpColor}
              style={{
                cursor: "pointer",
                userSelect: "none",
                borderRadius: "10px",
              }}
            >
              {relevant ? icpBy.name : icp}
            </Tag>
          </Text>
        </div>
      </div>
      {/* </Link> */}
    </Card>
  );
};

export default JobCardComponent;
{
  /* Skills */
}
{
  /* <div
            style={{
              marginTop: 12,
              fontSize: 12,
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <Text
              style={{
                whiteSpace: "nowrap",
                marginRight: "5px",
              }}
            >
              <strong>Skill:</strong>
            </Text>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
              }}
            >
              <div
                // size={"small"}
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "0px",
                }}
              >
                {firstTwoTechnology?.map((data) => (
                  <Tag
                    style={{
                      borderRadius: "20px",
                      color: "#13487D",
                      fontWeight: "600",
                      border: "2px solid #C1D6EE",
                    }}
                  >
                    {data?.value}
                  </Tag>
                ))}
                {remainingTechnologyCount > 0 && (
                  <Tooltip
                    placement="top"
                    title={
                      <div
                        style={{
                          gap: "4px",
                          maxWidth: "200px",
                          wordWrap: "break-word",
                        }}
                      >
                        {remainingTechnology.map((data, i) => (
                          <span key={i} style={{ whiteSpace: "nowrap" }}>
                            <p style={{ fontSize: "12px", margin: 0 }}>
                              {data.value}
                            </p>
                          </span>
                        ))}
                      </div>
                    }
                  >
                    <Button
                      type="primary"
                      shape="circle"
                      style={{
                        backgroundColor: "#1A90FF",
                        border: "none",
                        borderRadius: "16px",
                        width: "18px",
                        height: "22px",
                        fontWeight: "bold",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0px 4px 6px rgb(26,144,255,0.3)",
                      }}
                    >
                      +{remainingTechnologyCount}
                    </Button>
                  </Tooltip>
                )}
              </div>
            </div>
          </div> */
}
